import { render, staticRenderFns } from "./SurveyResponseList.vue?vue&type=template&id=5516671c&"
import script from "./SurveyResponseList.vue?vue&type=script&lang=js&"
export * from "./SurveyResponseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports